import { arrInc } from '../../../fun-js-lib/arr'
import { canvasFonted } from '../../../fun-js-lib/canvas'
import Rect from '../../../fun-js-lib/geometry/Rect'
import { drawDiagonal, fillStyled, fillTextStyled, textWidth } from '../../canvasDraw'
import { textCentered } from '../drawUtils'
import { mainFrameRect } from '../rects'
import { fillMechanizationContent } from './mechanizationContent'

/**
 * @param {CanvasRenderingContext2D} context 
 * @param {string} linesColor 
 */
export function drawShiftsLines (context, linesColor) {
  let rect = shiftsRect()
  const thickVerticals = () => {
    context.fillRect(rect.x, rect.y, 5, rect.h)
    context.fillRect(rect.x + 190, rect.y, 5, rect.h)
    context.fillRect(rect.x + 190 + 480, rect.y, 5, rect.h)
  }
  const thickHorizontal = () => {
    context.fillRect(rect.x, rect.y + 120, rect.w, 5)
  }
  const nJobThinHorizontal = () => {
    context.fillRect(rect.x + 190, rect.y + 40, 480, 1)
  }
  const nJob4ThinVerticals = () => {
    context.fillRect(rect.x + 190 + 90, rect.y + 40, 1, 360 - 40)
    context.fillRect(rect.x + 190 + 90 * 2, rect.y + 40, 1, 360 - 40)
    context.fillRect(rect.x + 190 + 90 * 3, rect.y + 40, 1, 360 - 40)
    context.fillRect(rect.x + 190 + 90 * 4, rect.y + 40, 1, 360 - 40)
  }
  const thinHorizontals = () => {
    context.fillRect(rect.x, rect.y + 120 + 80, rect.w, 1)
    context.fillRect(rect.x, rect.y + 120 + 80 * 2, rect.w, 1)
  }
  fillStyled(context, linesColor, () => {
    thickVerticals()
    thickHorizontal()
    nJobThinHorizontal()
    nJob4ThinVerticals()
    thinHorizontals()
  })
}

/**
 * @param {CanvasRenderingContext2D} context 
 * @param {string} linesColor 
 * @param {import('../../constructionLog').LogPage} page 
 */
export function textShifts (context, linesColor, page) {
  let rect = shiftsRect()

  fillStyled(context, linesColor, () => {
    textCentered(context, 'Смена', rect.x, rect.y + 70, 190)

    canvasFonted(context, '26px Arial', () => {
      textCentered(context, 'Броj радника', rect.x + 190, rect.y + 30, 480)
    })

    canvasFonted(context, '22px Arial', () => {
      let texts3 = ['Грађ.', 'За-', 'Техн.', 'Ос-']
      texts3.forEach((t, i) =>
        textCentered(context, t, rect.x + 190 + i * 90, rect.y + 75, 90))

      let texts4 = ['радн.', 'нат.', 'особ.', 'тали']
      texts4.forEach((t, i) =>
        textCentered(context, t, rect.x + 190 + i * 90, rect.y + 95, 90))

      textCentered(context, 'Укупно', rect.x + 190 + 90 * 4, rect.y + 80, 120)
    })

    textCentered(context, 'Механизациjа', rect.x + 190 + 480, rect.y + 70, 280)
  })

  let widths = [90, 90, 90, 90, 120]
  let shiftContents = arrInc(3).map(i => [
    page.shifts[i].construction_workers,
    page.shifts[i].craft_workers,
    page.shifts[i].technical_staff,
    page.shifts[i].others,
    page.shifts[i].nEmployeeTotal])
  widths.reduce((acc, cur, columnI) => {
    arrInc(3).forEach(shiftI => {
      let text = '' + shiftContents[shiftI][columnI]
      let cell = Rect.plain({
        x: rect.x + 190 + acc + (columnI === 0 ? 7 : 3),
        y: rect.y + 120 + 80 * shiftI + (shiftI === 0 ? 7 : 3),
        w: cur - (columnI === 0 ? 9 : 4),
        h: 80 - (shiftI === 0 ? 9 : 5)
      })
      textCenteredOrDiagonal(context, text, cell, 30)
    })
    return acc + cur
  }, 0)
  fillMechanizationContent(context, page)

  let ises = ['I', 'II', 'III']
  ises.forEach((t, i) => {
    let x = rect.x + 190 / 2 - textWidth(context, t) / 2
    let y = rect.y + 120 + 80 * i + 55
    fillTextStyled(context, t, x, y, linesColor)
  })
}

export function shiftsRect () {
  let frame = mainFrameRect()
  return Rect.plain({
    x: frame.x + 840,
    y: frame.y + 250,
    w: 190 + 480 + 280,
    h: 360
  })
}

/**
 * @param {CanvasRenderingContext2D} context 
 * @param {string} text 
 * @param {Rect} rect
 * @param {number} textHeight
 */
function textCenteredOrDiagonal (context, text, rect, textHeight) {
  if (text === '') {
    drawDiagonal(context, rect)
  } else {
    let y = rect.y + rect.h / 2 + textHeight / 2
    textCentered(context, text, rect.x, y, rect.w)
  }
}